export type Track = 'nursing' | 'midwifery';

// A user's product track is derived from their subscription plan.
// Midwifery plans are prefixed with "midwifery" (e.g. "midwifery-90days").
export function getTrackFromPlan(plan?: string | null): Track {
  return plan && plan.toLowerCase().startsWith('midwifery') ? 'midwifery' : 'nursing';
}
